import * as React from 'react'
import { connect } from 'react-redux'
import { navigateToArticle } from '../../actions/answers'
import { currentParamsSelector } from '../../selectors/navigation'
import { RootState } from '../../types/rootstate'

interface StateProps {
  params: any
}

interface DispatchProps {
  navigateToArticle: (userId: number, answersId: number, articleId: number) => void
}

interface OwnProps {
  field: any
}

type MainProps = StateProps & DispatchProps & OwnProps

function mapStateToProps(state: RootState): StateProps {
  return {
    params: currentParamsSelector(state)
  }
}

function mapDispatchToProps(dispatch): DispatchProps {
  return {
    navigateToArticle: (userId: number, answersId: number, articleId: number) =>
      dispatch(navigateToArticle(userId, answersId, articleId))
  }
}

interface MainState {}

class ArticleLinkComponent extends React.Component<MainProps, MainState> {

  handleArticleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    this.props.navigateToArticle(
      this.props.params.userId,
      this.props.params.formId,
      this.props.field.articleId
    )
  }

  handleArticleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.props.navigateToArticle(
        this.props.params.userId,
        this.props.params.formId,
        this.props.field.articleId
      )
    }
  }

  render() {
    return (
      <div
        className={this.props.field.className !== '' ? this.props.field.className : 'col-xs-6'}
        id={this.props.field.categoryId}
      >
        <div
          className='answers-category-item'
          role='link'
          tabIndex={0}
          onClick={this.handleArticleClick}
          onKeyDown={this.handleArticleKeyDown}
        >

          {this.props.field.icon &&
          <div
          className='answers-category-item-icon-wrapper'
          >
            <img
              className='answers-category-item-icon'
              src={this.props.field.icon}
              style={{ height: this.props.field.iconHeight, width: this.props.field.iconHeight }}
              alt=''
            />
          </div>
          }

          {this.props.field.label &&
          <span
          className='answers-category-item-label'>
            {this.props.field.label}
          </span>
          }
        </div>

      </div>
    )
  }
}

const ArticleLink = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(ArticleLinkComponent)


export {
  ArticleLink
}
